import apiCarga from "@/services/vex/apiCarga";

async function buscarPneusDinamicos() {
    const uri = "/marcas-pneus";

    const result = await apiCarga.get(uri);

    let status = result.data.status;
    let OK = status == "OK";

    if (OK)
        return result.data.data;
    else
        throw new Error(result.data.message);
}

export default buscarPneusDinamicos;
